const LOAD_DATA = 'LOAD_DATA';
const SET_ERROR = 'SET_ERROR';
const CLEAR_ERROR = 'CLEAR_ERROR';
const CLEAR_DATA = 'CLEAR_DATA';

export function loadData (data) {
  return {
    type: LOAD_DATA,
    payload: {
      loading: false,
      ...data,
    }
  }
}

export function clearData () {
  return {
    type: CLEAR_DATA,
    payload: {
      loading: true,
      VT: [],
      BND: [],
      BTC: [],
      dates: [],
    }
  }
}

export function setError (error) {
  return {
    type: SET_ERROR,
    payload: error,
  }
}

export function clearError () {
  return {
    type: CLEAR_ERROR,
    payload: null,
  }
}

const initialState = {
  loading: true,
  error: null,
  VT: [],
  BND: [],
  BTC: [],
};

export default function tickers (state = initialState, action) {
  switch (action.type) {
    case LOAD_DATA:
    case CLEAR_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case SET_ERROR:
    case CLEAR_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/tickers.js